<script setup lang="ts">
import { IonItem, IonLabel, IonTextarea } from '@ionic/vue'

const model = defineModel()
defineProps<{
	label?: string
	labelPosition?: "stacked" | "floating" | "fixed" | undefined
	placeholder?: string
	rows?: number
}>()

</script>

<template>
	<ion-item>
		<ion-label v-if="label" :position="labelPosition ?? 'stacked'" class="form-label">{{ label }}</ion-label>
		<ion-textarea
			v-model="model"
			:placeholder="placeholder"
			:rows="rows ?? 3"
			class="w-full py-4 px-4 bg-green-50 prose prose-sm sm:prose-base lg:prose-lg xl:prose-2xl focus:outline-none"
		/>
	</ion-item>
</template>

